// src/app/adapters/custom-date-adapter.ts
import { NativeDateAdapter } from '@angular/material/core';

export class CustomDateAdapter extends NativeDateAdapter {
  override getFirstDayOfWeek(): number {
    return 1; // 0 = Sunday, 1 = Monday, etc.
  }
}
